import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Sparkles } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

function pickNext(totalReferrals, tiers) {
  if (totalReferrals >= 5) return null;
  if (totalReferrals === 0) {
    return { title: tiers.firstReferral, bonus: tiers.firstReferralBonus, need: 1 };
  }
  if (totalReferrals < 3) {
    return { title: tiers.silverLevel, bonus: tiers.silverBonusClub, need: 3 };
  }
  return { title: tiers.goldLevel, bonus: tiers.goldBonusMoney, need: 5 };
}

function NextTierBenefitCard({ totalReferrals = 0, className = '' }) {
  const { t, formatMessage } = useLanguage();
  const tiers = t.enrola.tiers;
  const row = pickNext(totalReferrals, tiers);

  if (!row) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className={`card-premium border-amber-200/80 bg-gradient-to-br from-amber-50 to-orange-50/50 p-5    ${className}`}
      >
        <p className="eyebrow text-amber-800 ">{tiers.goldLevelBadge}</p>
        <p className="mt-1 font-bold text-secondary-900 ">{tiers.allMilestonesUnlocked}</p>
        <p className="mt-1 text-sm text-secondary-600 ">{tiers.keepInviting}</p>
      </motion.div>
    );
  }
  const remaining = Math.max(0, row.need - totalReferrals);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`empty-state-panel relative overflow-hidden p-5 text-left ${className}`}
    >
      <div className="absolute right-3 top-3 opacity-10" aria-hidden="true">
        <Lock className="h-16 w-16 text-secondary-700 " />
      </div>
      <div className="relative flex items-start gap-3">
        <div className="icon-tile h-11 w-11 from-secondary-400 to-secondary-500">
          <Sparkles className="h-5 w-5 text-white" />
        </div>
        <div>
          <p className="stat-label">{tiers.nextBenefit}</p>
          <p className="font-bold text-secondary-900 ">{row.title}</p>
          <p className="mt-1 text-sm text-secondary-600 ">{row.bonus}</p>
          {remaining > 0 && (
            <p className="mt-2 text-xs font-medium text-orange-600 ">
              {formatMessage(tiers.referralsToUnlock, { count: remaining })}
            </p>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default NextTierBenefitCard;
